import { configureStore } from "@reduxjs/toolkit";
import feature1Reducer from "../features/feature1/feature1Slice";
import cartReducer from "../features/cart/cartSlice";
import userReducer from "../features/user/userSlice";
import authReducer from "../features/auth/authSlice"; // Import the auth slice
import addressReducer from "../features/address/addressSlice";
import profileReducer from "../features/profile/profileSlice";
import ordersReducer from "../features/orders/ordersSlice";
import prescriptionReducer from "../features/prescription/prescriptionSlice";
import GoogleLoginButtonReducer from "../features/social/googleSlice";
import userwalletReducer from "../features/userwallet/userwalletSlice"; 
import invoiceReducer from "../features/invoice/invoiceSlice" 
import checkoutReducer from "../features/checkout/checkoutSlice"
import facebookAuthReducer from "../features/social/facebookSlice";
export const store = configureStore({
  reducer: {
    cart: cartReducer,
    feature1: feature1Reducer,
    user: userReducer,
    auth: authReducer,
    address: addressReducer,
    profile: profileReducer,
    orders: ordersReducer,
    prescriptions: prescriptionReducer,
    userwallet: userwalletReducer,
    googleAuth: GoogleLoginButtonReducer,
    invoice: invoiceReducer,
    checkout: checkoutReducer, 
    facebookAuth: facebookAuthReducer,
    },
});

export default store;
